<template>
	<!-- FIXME ne dolaze mailovi (registracija, potvrda registracije, zamjena lozinke) -->
	<Body class="graybg" />
	<ClientOnly>
		<BaseAuthUser>
			<div class="auth-layout">
				<div class="wrapper auth-wrapper">
					<div class="auth-sidebar-menu">
						<AuthMenu />
					</div>
					<div class="auth-content">
						<slot name="authContent" />
					</div>
				</div>
			</div>
		</BaseAuthUser>
		<template #fallback>
			<BaseThemeUiLoading />
		</template>
	</ClientOnly>
</template>

<script setup>
	const {insertAfter, prependTo, onMediaQuery} = useDom();
	const {matches: mobileBreakpoint} = onMediaQuery({
		query: '(max-width: 980px)',
		timeout: 500,
		enter: () => {
			insertAfter('.auth-sidebar-menu', '.auth-content h1');
		},
		leave: () => {
			prependTo('.auth-sidebar-menu', '.auth-wrapper');
		},
	});
</script>

<style lang="less" scoped>
	.auth-layout{border-bottom: 1px solid var(--gray);}
	.auth-wrapper{
		display: flex; padding-top: 49px; padding-bottom: 80px; align-items: flex-start;
		@media (max-width: @m){padding-top: 28px; padding-bottom: 32px;}	
	}
	.auth-sidebar-menu{
		flex: 0 0 216px;
		@media (max-width: @m){flex: inherit; margin-bottom: 24px;}	
	}

	.auth-content{
		padding: 8px 0 0 84px; max-width: 884px; flex: 1 1 auto;
		@media (max-width: @t){padding-left: 30px;}
		@media (max-width: @m){padding: 0; flex: 0 0 100%; max-width: 100%;}	
	}
	:deep(h1){
		font-size: 30px; padding: 0 0 22px;
		@media (max-width: @t){font-size: 24px;}
		@media (max-width: @m){font-size: 22px; padding-bottom: 16px;}
	}
	:deep(.auth-no-content){padding: 12px 0;}
	:deep(.counter){
		font-size: 16px; color: var(--blue);
		@media (max-width: @m){font-size: 14px;}	
	}
</style>
